exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".padding-top[_v-762b1d5d]{padding-top:20px}.gray[_v-762b1d5d]{background-color:hsla(0,0%,75%,.2)!important;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-762b1d5d&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/forms/MessageForm.vue
// module id = 314
// module chunks = 0